import React from "react";
import { Link } from "react-router-dom";
import "./TourPackages.css";
import { tourPackagesData } from "./tourPackagesData";

const TourPackages = () => {
  const tourData = Object.values(tourPackagesData); // convert object to array

  return (
    <div className="tourPackages">
      <h2 className="tourPackages-title">Travel Packages from Hyderabad</h2>
      <p className="tourPackages-subtitle">
        Discover exciting tours from Hyderabad including Goa beaches, Hampi
        heritage sites, Srisailam temple, Warangal forts, Vijayawada and more.
        Perfect for family holidays, weekend getaways, and cultural trips.
      </p>

      <div className="tourPackages-grid">
        {tourData.map((tour) => (
          <div className="tourCard" key={tour.slug}>
            <div className="tourCard-imgWrapper">
              <img src={tour.image} alt={tour.title} className="tourCard-img" />
              <span className="tourCard-tag">{tour.duration}</span>
            </div>
            <div className="tourCard-body">
              <h3>{tour.title}</h3>
              <div className="tourCard-footer">
                <span className="tourCard-price">{tour.price}</span>
                <Link to={`/tour-packages/${tour.slug}`}>
                  <button className="tourCard-btn">View Details</button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TourPackages;
